import { Component, Input, SimpleChanges, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import moment from 'moment';
import { debounceTime, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';
@Component({
  selector: 'app-details-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    NgSelectModule],
  templateUrl: './details-form.component.html',
  styleUrl: './details-form.component.css'
})
export class DetailsFormComponent implements OnDestroy {
  @Input() orderData?: any;
  @Input() ladata: any = [];

  private destroy$ = new Subject<void>();


  activeTab: 'original' | 'definitive' = 'original';

  detailsForm: FormGroup;
  models: any[] = [];
  brands: any[] = [];

  dealershipData: any = [];
  camposJson = ['vehicle_invoice_options_detail', 'vehicle_invoice_pre_options_detail', 'vehicle_invoice_pre_packs_detail', 'vehicle_invoice_pre_accessories_detail', 'vehicle_accessories'];
  camposPctg = ['vehicle_invoice_pre_discount_pctg', 'vehicle_invoice_pre_transport_discount_pctg', 'vehicle_invoice_pre_tax'];
  camposFactura_pre = [
    "vehicle_invoice_pre_vehicle",
    "vehicle_invoice_pre_packs",
    "vehicle_invoice_pre_packs_detail",
    "vehicle_invoice_pre_options",
    "vehicle_invoice_pre_options_detail",
    /*  "vehicle_invoice_pre_discount", */
    /*   "vehicle_invoice_pre_discount_pctg", */
    "vehicle_invoice_pre_promotion",
    /* "vehicle_invoice_pre_transport", */
    /* "vehicle_invoice_pre_transport_discount_pctg", */
    "vehicle_invoice_pre_accessories",
    "vehicle_invoice_pre_accessories_detail",
    "vehicle_invoice_pre_base_amount",
    /*   "vehicle_invoice_pre_tax",
      "vehicle_invoice_pre_tax_amount", */
    "vehicle_invoice_pre_total_amount"
  ];

  camposFactura = [
    "vehicle_invoice_vehicle",
    "vehicle_invoice_packs",
    "vehicle_invoice_packs_detail",
    "vehicle_invoice_options",
    "vehicle_invoice_options_detail",
    "vehicle_invoice_discount",
    "vehicle_invoice_discount_pctg",
    "vehicle_invoice_promotion",
    "vehicle_invoice_transport",
    "vehicle_invoice_transport_discount_pctg",
    "vehicle_invoice_accessories",
    "vehicle_invoice_accessories_detail",
    "vehicle_invoice_base_amount",
    "vehicle_invoice_tax",
    "vehicle_invoice_tax_amount",
    "vehicle_invoice_total_amount"
  ];

  constructor(private fb: FormBuilder, private modelService: ModelService, private alertService: AlertService) {

    this.detailsForm = this.fb.group({
      supplier_sale_type: ['', Validators.required],
      vehicle_billing_date: ['', Validators.required],
      dealership_id: [''],
      vehicle_model_code: ['', Validators.required],
      vehicle_options: ['', Validators.required],
      vehicle_accessories: ['', Validators.required],
      vehicle_discount_code: ['', Validators.required],
      vehicle_payment_date: ['', Validators.required],
      vehicle_invoice_vehicle: ['', Validators.required],
      vehicle_invoice_packs: ['', Validators.required],
      vehicle_invoice_packs_detail: this.fb.array([]),
      vehicle_invoice_options: ['', Validators.required],
      vehicle_invoice_options_detail: this.fb.array([]),
      vehicle_invoice_discount: ['', Validators.required],
      vehicle_invoice_discount_pctg: ['', Validators.required],
      vehicle_invoice_promotion: ['', Validators.required],
      vehicle_invoice_transport: ['', Validators.required],
      vehicle_invoice_transport_discount_pctg: ['', Validators.required],
      vehicle_invoice_accessories: ['', Validators.required],
      vehicle_invoice_accessories_detail: this.fb.array([]),
      vehicle_invoice_base_amount: ['', Validators.required],
      vehicle_invoice_tax: ['', Validators.required],
      vehicle_invoice_tax_amount: ['', Validators.required],
      vehicle_invoice_total_amount: ['', Validators.required],
      vehicle_invoice_pre: ['', Validators.required],
      vehicle_invoice_pre_vehicle: ['', Validators.required],
      vehicle_invoice_pre_packs: ['', Validators.required],
      vehicle_invoice_pre_packs_detail: ['', Validators.required],
      vehicle_invoice_pre_options: ['', Validators.required],
      vehicle_invoice_pre_options_detail: ['', Validators.required],
      vehicle_invoice_pre_discount: ['', Validators.required],
      vehicle_invoice_pre_discount_pctg: ['', Validators.required],
      vehicle_invoice_pre_promotion: ['', Validators.required],
      vehicle_invoice_pre_transport: ['', Validators.required],
      vehicle_invoice_pre_transport_discount_pctg: ['', Validators.required],
      vehicle_invoice_pre_accessories: ['', Validators.required],
      vehicle_invoice_pre_accessories_detail: ['', Validators.required],
      vehicle_invoice_pre_base_amount: ['', Validators.required],
      vehicle_invoice_pre_tax: ['', Validators.required],
      vehicle_invoice_pre_tax_amount: ['', Validators.required],
      vehicle_invoice_pre_total_amount: ['', Validators.required],
    });
  }

  ngAfterViewInit() {
    this.addDebouncedValueChange(this.detailsForm.get('vehicle_invoice_tax'), () =>
      this.calculateTaxAmount()
    );
    this.addDebouncedValueChange(this.detailsForm.get('vehicle_invoice_discount_pctg'), () =>
      this.calculateDiscountAmount()
    );
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
        this.brands = this.ladata.brands;
        this.dealershipData = this.ladata.dealershipData;
        if (this.dealershipData)this.dealershipData = this.dealershipData.sort((a: { name: string }, b: { name: string }) =>
          a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
        );
      }
    }
    if (changes['orderData']) {
      if (this.orderData) {
        this.refrescarFormulario();
      }
    }
  }
  private addDebouncedValueChange(control: any, callback: () => void): void {
    control?.valueChanges.pipe(debounceTime(1000), takeUntil(this.destroy$)).subscribe(callback);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

    refrescarFormulario() {
    this.updateFieldAccessibility();
    if (this.models.length === 0) {
      if (this.orderData.vehicle_brand_id) {
        this.onBrandChange(this.orderData.vehicle_brand_id);
      }
    }

    for (const key in this.orderData) {
      const control = this.detailsForm.controls[key];
      const value = this.orderData[key];
      if (control) {
        switch (key) {
          case 'delivery_first_expected_date':
            control.setValue(value ? moment(value).format('DD/MM/YYYY') : '');
            break;
          /* case 'vehicle_options':
            this.detailsForm.get('vehicle_options')?.setValue(this.arrayToString(this.orderData.vehicle_options));
            break;
          case 'vehicle_accessories':
            this.detailsForm.get('vehicle_accessories')?.setValue(this.arrayToString(this.orderData.vehicle_accessories));
            break; */
          default:
            control.setValue(value);
            break;
        }
      }
    }

    this.updateFieldAccessibility();

    for (const key in this.orderData.pff) {
      const control = this.detailsForm.controls[key];
      let value = this.orderData.pff[key];
      if (control) {
        switch (key) {
          case 'vehicle_invoice_options_detail':

            if (this.orderData.pff.vehicle_invoice_options_detail != null) {
              this.detailsForm.setControl('vehicle_invoice_options_detail', this.buildDetailArray(JSON.parse(this.orderData.pff.vehicle_invoice_options_detail)));
            }
            break;
          case 'vehicle_invoice_packs_detail':

            if (this.orderData.pff.vehicle_invoice_packs_detail != null) {
              this.detailsForm.setControl('vehicle_invoice_packs_detail', this.buildDetailArray(JSON.parse(this.orderData.pff.vehicle_invoice_packs_detail)));
            }
            break;
          case 'vehicle_invoice_accessories_detail':


            if (this.orderData.pff.vehicle_invoice_accessories_detail != null) {
              this.detailsForm.setControl('vehicle_invoice_accessories_detail', this.buildDetailArray(JSON.parse(this.orderData.pff.vehicle_invoice_accessories_detail)));
            }
            break;
          case 'vehicle_invoice_pre_accessories_detail':
            this.detailsForm.get('vehicle_invoice_pre_accessories_detail')?.setValue(this.formatOptionsJson(this.orderData.pff.vehicle_invoice_pre_accessories_detail));
            break;
          case 'vehicle_invoice_pre_options_detail':
            this.detailsForm.get('vehicle_invoice_pre_options_detail')?.setValue(this.formatOptionsJson(this.orderData.pff.vehicle_invoice_pre_options_detail));
            break;
          case 'vehicle_invoice_pre_packs_detail':
            this.detailsForm.get('vehicle_invoice_pre_packs_detail')?.setValue(this.formatOptionsJson(this.orderData.pff.vehicle_invoice_pre_packs_detail));
            break;

          default:
            control.setValue(value);
            break;
        }


      }
    }
    this.alertService.close();
  }

  formatOptions2(jsonString: string): string {
    try {
      const options = JSON.parse(jsonString);
      if (!Array.isArray(options)) return '';
      return options
        .filter(item => typeof item === 'object' && item !== null)
        .map(item => {
          return Object.entries(item)
            .filter(([key, _]) => key !== 'amount') // 👈 filtra fuera la clave 'amount'
            .map(([_, value]) => `${value}`)
            .join(',');
        })
        .join('\n');
    } catch (error) {
      console.error('Invalid JSON string:', error);
      return '';
    }
  }
  arrayToString(jsonString: string): string {
    return jsonString.replace(/[\[\]"]/g, '');
  }

  stringToArray(original: string): string[] {
    return original
      .split(',')
      .map(item => item.trim()); // Quita espacios en caso de que los haya
  }

  formatOptions(jsonString: string): string {
    try {
      const options = JSON.parse(jsonString);
      if (!Array.isArray(options)) return '';

      return options
        .filter(item => typeof item === 'string')
        .join(', ');
    } catch (error) {
      console.error('Invalid JSON string:', error);
      return '';
    }
  }
  formatOptionsJson(jsonString: string): any {
    try {
      const options = JSON.parse(jsonString || '[]');
      if (Array.isArray(options)) {
        return options;
      }
    } catch (e) {
      console.error('Error parsing options JSON', e);
      return '';

    }

    /*  try {
       const options = JSON.parse(jsonString);

       if (!Array.isArray(options)) return '';

       return options
         .filter(item => item && typeof item === 'object')
         .map(item => `${item.name}: €${item.amount}`)
         .join(',\n');
     } catch (error) {
       console.error('Invalid JSON string:', error);
       return '';
     } */
  }

  updateFieldAccessibility() {
    var rules = this.orderData?.rules;
    // Deshabilitar todos los campos por defecto
    for (const field in this.detailsForm.controls) {
      if (this.detailsForm.controls.hasOwnProperty(field)) {
        this.detailsForm.get(field)?.disable();
      }
    }

    // Habilitar solo los campos con valor 'w' en las reglas
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.detailsForm.get(field)?.enable();
      }
    }

    this.detailsForm.get('vehicle_invoice_discount')?.disable();
    this.detailsForm.get("vehicle_invoice_tax_amount")?.disable();
    this.detailsForm.get("vehicle_invoice_total_amount")?.disable();
    this.detailsForm.get("vehicle_invoice_base_amount")?.disable();
  }




  buildDetailArray(data: any[]): FormArray {
    return this.fb.array(
      data.map(item => this.fb.group({
        name: [item.name || ''],
        amount: [item.amount || '']
      }))
    );
  }


  checkUpdateForm(): boolean {
    if (this.detailsForm.dirty) {
      return true;
    } else {
      return false;
    }
  }
  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  async onBrandChange(value: any) {
    if (!value) return;
    var brand_reference: any = '';
    if (typeof value === 'string') {
      brand_reference = value;
    } else {
      brand_reference = value.target.value;
    }

    try {
      const data = await this.modelService.getDataByBrand(brand_reference).toPromise();
      this.models = data.data;

      if (brand_reference != this.orderData.vehicle_brand_id) {
        this.detailsForm.get('vehicle_model_id2')?.setValue('');
      }
    } catch (error) {
      console.error('There was an error!', error);
    }
  }


  /////////////////////////////////////


  setActiveTab(tab: 'original' | 'definitive') {
    this.activeTab = tab;
  }


  get optionsDetailArray(): FormArray {
    return this.detailsForm.get('vehicle_invoice_options_detail') as FormArray;
  }
  get accessoriesDetailArray(): FormArray {
    return this.detailsForm.get('vehicle_invoice_accessories_detail') as FormArray;
  }
  get packDetailArray(): FormArray {
    return this.detailsForm.get('vehicle_invoice_packs_detail') as FormArray;
  }

  getFormArray(key: string): FormArray {
    return this.detailsForm.get(key) as FormArray;
  }

  addToFormArray(key: string) {
    const group = this.fb.group({
      name: [''],
      amount: ['']
    });
    group.get('amount')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.calculateBaseAmount();
    });
    this.getFormArray(key).push(group);
  }

  removeFromFormArray(index: number, key: string): void {
    this.getFormArray(key).removeAt(index);
    this.calculateBaseAmount();
  }

  getVehicleImportValue(): number {
    let value = parseFloat(this.detailsForm.get('vehicle_invoice_vehicle')?.value) || 0;
    const keys = ['vehicle_invoice_options_detail', 'vehicle_invoice_accessories_detail', 'vehicle_invoice_packs_detail'];
    let totalAmount = 0;

    keys.forEach(key => {
      const formArray = this.getFormArray(key); // Asumes que esto devuelve un FormArray

      formArray.controls.forEach(group => {
        const amount = parseFloat(group.get('amount')?.value || 0);
        totalAmount += isNaN(amount) ? 0 : amount;
      });
    });
    return value + totalAmount;
  }

  calculateTaxAmount(): void {
    const tax = parseFloat(this.detailsForm.get('vehicle_invoice_tax')?.value);
    const vehicle_import = this.getVehicleImportValue();
    if (!isNaN(tax)) {
      const value = (vehicle_import * tax / 100).toFixed(2);
      this.detailsForm
        .get('vehicle_invoice_tax_amount')
        ?.setValue(value, { emitEvent: false });
    }
    this.calculateTotalAmount();
  }

  calculateDiscountAmount(): void {
    const dsc = parseFloat(this.detailsForm.get('vehicle_invoice_discount_pctg')?.value);
    const vehicle_import = this.getVehicleImportValue();
    if (!isNaN(dsc)) {
      const value = (vehicle_import * dsc / 100).toFixed(2);
      this.detailsForm
        .get('vehicle_invoice_discount')
        ?.setValue(value, { emitEvent: false });
    }
    this.calculateBaseAmount()
  }

  calculateTotalAmount(): void {
    const base = parseFloat(this.detailsForm.get('vehicle_invoice_base_amount')?.value);
    const imp = parseFloat(this.detailsForm.get('vehicle_invoice_tax_amount')?.value);
    const value = (base + imp);

    if (!isNaN(value)) {
      this.detailsForm
        .get('vehicle_invoice_total_amount')
        ?.setValue(value.toFixed(2), { emitEvent: false });
    }
  }

  calculateBaseAmount(): void {
    const transport = parseFloat(this.detailsForm.get('vehicle_invoice_transport')?.value);
    const dsc = parseFloat(this.detailsForm.get('vehicle_invoice_discount')?.value);
    const vehicle_import = this.getVehicleImportValue();

    var value = (vehicle_import + transport - dsc);

    if (!isNaN(value)) {
      this.detailsForm
        .get('vehicle_invoice_base_amount')
        ?.setValue(value.toFixed(2), { emitEvent: false });
    }
    this.calculateTotalAmount();
  }

isFieldReadOnly(field: string): boolean {
  if (field === 'vehicle_invoice_packs_detail') {
    return false;
  }

  return this.orderData.rules?.[field] === 'r';
}
}
